module.exports = __webpack_public_path__ + "img/character07.a86eb455.png";